import { endpoints } from 'Constants';

const reportsServices = {
	getCouponTransactions: (params) => ({
		baseURL: endpoints.REPORTS.COUPON_TRANSACTIONS(),
		method: 'GET',
		params: params?.query,
	}),
	getCouponTransactionsOverview: (params) => ({
		baseURL: endpoints.REPORTS.COUPONS_TRANSACTIONS_OVERVIEW(),
		method: 'GET',
		params: params?.query,
	}),
	getPaymentRequestTransactions: (params) => ({
		baseURL: endpoints.REPORTS.PAYMENT_REQUEST_TRANSACTIONS(),
		method: 'GET',
		params: params?.query,
	}),
	getPaymentRequestTransactionsOverview: (params) => ({
		baseURL: endpoints.REPORTS.PAYMENT_REQUEST_TRANSACTIONS_OVERVIEW(),
		method: 'GET',
		params: params?.query,
	}),
	getTransactionPackage: (params) => {
		const { businessId } = params;
		delete params.businessId;
		return {
			baseURL: endpoints.REPORTS.TRANSACTION_PACKAGE(businessId),
			method: 'GET',
			params,
		};
	},
	getChartPackage: (params) => ({
		baseURL: endpoints.REPORTS.CHART_PACKAGE(),
		method: 'GET',
		params: params,
	}),
	getChartPackageOffcb: (params) => ({
		baseURL: endpoints.REPORTS.CHART_PACKAGE_OFFCB(),
		method: 'GET',
		params: params,
	}),
	getTransactionPackageOffcb: (params) => ({
		baseURL: endpoints.REPORTS.TRANSACTION_PACKAGE_OFFCB(),
		method: 'GET',
		params: params,
	}),
};

export default reportsServices;
